<script setup>
import {computed} from 'vue'
import Button from "@/common/Button.vue"
import {useThemesStore} from '@/stores/themes'

const themesStore = useThemesStore()

const sectionName = computed(() => themesStore.sectionName)
const sectionsData = computed(() => themesStore.sectionsData)

const selectedSectionTitle = computed(() => {
    const activeSection = sectionsData.value.find(obj => obj.tableName === sectionName.value)
    return activeSection ? activeSection.title : 'Sections'
})

const setSectionName = (tableName) => {
    themesStore.setSectionName(tableName)
}
</script>

<template>
    <div class="dropdown">
        <Button class="btn-sm dropdown-toggle" data-bs-toggle="dropdown">
            {{ selectedSectionTitle }}
        </Button>

        <div class="dropdown-menu">
            <button
                v-for="section in sectionsData"
                :key="section.tableName"
                :class="{'active': section.tableName === sectionName}"
                class="dropdown-item"
                type="button"
                @click="setSectionName(section.tableName)"
            >
                {{ section.title }}
            </button>
        </div>
    </div>
</template>